import { useTranslation } from 'react-i18next';
import { Typography, Container } from '@mui/material';

const NotFoundPage = () => {
    const { t } = useTranslation();
    return (
        <Container sx={{ mt: 6 }}>
            <Typography variant="h1" align="center">
                {t('Page not found')}
            </Typography>
            <Typography variant="body1" align="center">
                {t('The page you are looking for does not exist.')}
            </Typography>
        </Container>
    );
};

export default NotFoundPage;